/* =========================================================
   DOPAMEAN — Related products Load More
   `<product-recommendations>` loads its grid asynchronously.
   We watch for it, then wire a Load more button that pulls
   random products from a hidden server-rendered pool and
   appends them in batches (one row per click). Pool is
   shuffled per page load so the order feels random.
   ========================================================= */
(function () {
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function handlesInGrid(grid) {
    var set = new Set();
    grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) set.add(m[1]);
    });
    return set;
  }

  function shuffleGrid(grid) {
    if (!grid || grid.dataset.dpmShuffled === '1') return;
    var items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    if (items.length <= 1) {
      grid.dataset.dpmShuffled = '1';
      return;
    }
    shuffle(items).forEach(function (item) { grid.appendChild(item); });
    grid.dataset.dpmShuffled = '1';
  }

  /* Parse a price string from a rendered card (e.g. "$45.00", "€45,00",
     "Rs. 1,299"). Strips non-numeric chars, treats the last separator
     as decimal, returns price in cents. Returns null if no number found. */
  function parsePriceCentsFromText(text) {
    if (!text) return null;
    var m = text.match(/[\d.,]+/);
    if (!m) return null;
    var num = m[0];
    var parts = num.split(/[.,]/);
    var integer, decimal;
    if (parts.length === 1) {
      integer = parts[0];
      decimal = '00';
    } else {
      decimal = parts[parts.length - 1];
      integer = parts.slice(0, -1).join('');
      if (decimal.length === 1) decimal += '0';
      if (decimal.length > 2) {
        integer = integer + decimal.slice(0, -2);
        decimal = decimal.slice(-2);
      }
    }
    var cents = parseInt(integer, 10) * 100 + parseInt(decimal, 10);
    return isNaN(cents) ? null : cents;
  }

  function getCardPriceCents(item) {
    if (item.dataset.priceCents) {
      var p = parseInt(item.dataset.priceCents, 10);
      return isNaN(p) ? null : p;
    }
    var el = item.querySelector(
      '.price__sale .price-item--sale, ' +
      '.price-item--sale, ' +
      '.price__regular .price-item--regular, ' +
      '.price-item--regular, ' +
      '.price-item'
    );
    return el ? parsePriceCentsFromText(el.textContent) : null;
  }

  function filterByPrice(items, basePrice, tolerance) {
    if (!basePrice || tolerance >= 1) return items;
    var min = basePrice * (1 - tolerance);
    var max = basePrice * (1 + tolerance);
    return items.filter(function (item) {
      var p = getCardPriceCents(item);
      if (p == null) return true; /* keep items we can't read — safer than dropping */
      return p >= min && p <= max;
    });
  }

  function bind(section) {
    var grid = section.querySelector('[data-dpm-related-grid]');
    if (!grid) return;

    var host = section.matches('product-recommendations')
      ? section
      : section.querySelector('product-recommendations');
    var basePrice = host ? parseInt(host.dataset.dpmBasePrice, 10) : NaN;
    var tolerancePct = host ? parseInt(host.dataset.dpmPriceTolerance, 10) : NaN;
    if (isNaN(basePrice)) basePrice = 0;
    if (isNaN(tolerancePct)) tolerancePct = 50;
    var tolerance = tolerancePct / 100;

    /* Price-match the recommendations grid. Drop items outside the band.
       If filtering would empty the grid (e.g. price band too tight),
       fall back to showing the original set so the section never looks
       broken on a mis-tuned setting. */
    var gridItems = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    var kept = filterByPrice(gridItems, basePrice, tolerance);
    if (kept.length > 0 && kept.length < gridItems.length) {
      gridItems.forEach(function (item) {
        if (kept.indexOf(item) === -1) item.remove();
      });
    }

    /* Always shuffle the (now price-matched) grid order on every
       pageview so visitors see a fresh sequence each time. */
    shuffleGrid(grid);

    var pool = section.querySelector('[data-dpm-related-pool]');
    var btn  = section.querySelector('[data-dpm-related-loadmore]');
    if (!pool || !btn) return;
    if (btn.dataset.dpmBound === '1') return;
    btn.dataset.dpmBound = '1';

    var batchSize = parseInt(pool.dataset.batchSize, 10) || 10;

    /* Shuffle the pool items in-place so each pageview gets a
       different order of "random" products. */
    var items = Array.from(pool.querySelectorAll('[data-pool-item]'));
    shuffle(items).forEach(function (item) { pool.appendChild(item); });

    /* Drop any pool item that's already shown in the main grid
       (recommendations + pool may overlap). */
    var present = handlesInGrid(grid);
    pool.querySelectorAll('[data-pool-item]').forEach(function (item) {
      if (present.has(item.dataset.handle)) item.remove();
    });

    /* Price-match the pool too — uses data-price-cents which is
       server-rendered, so this is exact (no DOM parsing). */
    var poolItems = Array.from(pool.querySelectorAll('[data-pool-item]'));
    var poolKept = filterByPrice(poolItems, basePrice, tolerance);
    poolItems.forEach(function (item) {
      if (poolKept.indexOf(item) === -1) item.remove();
    });

    if (!pool.querySelector('[data-pool-item]')) {
      btn.hidden = true;
      return;
    }

    btn.addEventListener('click', function () {
      var queue = Array.from(pool.querySelectorAll('[data-pool-item]')).slice(0, batchSize);
      queue.forEach(function (item) {
        item.classList.add('dpm-just-loaded');
        grid.appendChild(item);
        /* Strip the marker after the animation so re-renders don't re-trigger. */
        setTimeout(function () { item.classList.remove('dpm-just-loaded'); }, 600);
      });
      if (!pool.querySelector('[data-pool-item]')) btn.hidden = true;
    });
  }

  function ready(section) {
    /* The grid is server-rendered inside the Liquid template, but
       recommendations only paint once Shopify resolves the AJAX
       fetch. We bind as soon as at least one card exists. */
    if (section.querySelector('[data-dpm-related-grid] .grid__item')) {
      bind(section);
      return;
    }
    var host = section.querySelector('product-recommendations') || section;
    var obs = new MutationObserver(function () {
      if (section.querySelector('[data-dpm-related-grid] .grid__item')) {
        bind(section);
        obs.disconnect();
      }
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.related-products').forEach(ready);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) init(e.target);
  });
})();
